@if (isVisible()) {
  <div class="preview-banner">
    <div
      class="preview-banner__bg-image"
      [style.background-image]="'url(assets/images/banners/issues-banner-bg.png)'"
    ></div>

    <div class="preview-banner__content">
      <div class="preview-banner__text">
        <div class="preview-banner__title">
          <svg
            class="preview-banner__info-icon"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" stroke="#050224" stroke-width="2" />
            <line x1="12" y1="16" x2="12" y2="12" stroke="#050224" stroke-width="2" stroke-linecap="round" />
            <circle cx="12" cy="8" r="1" fill="#050224" />
          </svg>
          <span>Issues in preview</span>
        </div>
        <div class="preview-banner__description">
          <p>
            Issues is a new way to cut through alert noise. Instead of hundreds of individual findings, Zenity groups
            posture findings, runtime detections, and graph-based relationships into a single, prioritized risk, so you
            can act on what matters.
          </p>
          <p>
            You're seeing this early because your feedback shapes how this feature ships.<br />
            Explore Issues, then share what you think using the feedback button.
          </p>
        </div>
      </div>
      <a class="preview-banner__link" href="https://docs.zenity.io" target="_blank" rel="noopener noreferrer">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2V3Z"
            stroke="#6e32e0"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7V3Z"
            stroke="#6e32e0"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Read more
      </a>
    </div>

    <button type="button" class="preview-banner__close" aria-label="Dismiss banner" (click)="close()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 6L6 18M6 6l12 12"
          stroke="#696879"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
}
